import styled from 'styled-components';
import { Menu, Dropdown, Select } from 'antd';

export const DesktopMenu = styled(Menu)`
  font-size: 16px !important;
  line-height: 24px;
  gap: 16px;
  border: none !important;
  @media (max-width: 1024px) {
    display: none;
  }

  .ant-menu-title-content {
    font-weight: 500 !important;
  }

  .ant-menu-submenu-arrow {
  color: rgba(191, 197, 210, 1);
  left: calc(100% + 5px);
  display: block !important;
  transform: rotate(90deg) !important;
}

  .ant-menu-item-active {
  color: rgba(205, 97, 21, 1) !important;
  background: rgba(255, 243, 232, 1) !important;
  border-radius: 12px !important;
  height: 48px;
  display: flex !important;
  align-items: center !important;
  }

  .ant-menu-item-selected::after {
  border-bottom-color: transparent !important;
  }

  .ant-menu-item-selected {
  color: rgba(205, 97, 21, 1) !important;
  background: rgba(255, 243, 232, 1) !important;
  border-radius: 12px !important;
  height: 48px;
  display: flex !important;
  align-items: center !important;
  }

  .ant-menu-item-active::after {
  border-bottom-color: transparent !important;
  }

  .ant-menu-submenu-active::after {
  border-bottom-color: transparent !important;
  }

  .ant-menu-submenu-selected::after {
  border-bottom-color: transparent !important;
  }

  .ant-menu-submenu-selected {
  color: rgba(205, 97, 21, 1) !important;
  background: rgba(255, 243, 232, 1) !important;
  padding-right: 25px !important;
  border-radius: 12px !important;
  height: 48px;
  display: flex !important;
  align-items: center !important;

  .ant-menu-submenu-title {
    color: rgba(205, 97, 21, 1) !important;
  }
  }

  .ant-menu-submenu {
  padding-right: 25px !important;
  }

  .ant-menu-submenu-active {
  color: rgba(205, 97, 21, 1) !important;
  background: rgba(255, 243, 232, 1) !important;
  padding-right: 25px !important;
  border-radius: 12px !important;
  height: 48px;
  display: flex !important;
  align-items: center !important;
  }
`;

export const MobileBurgerIconWrapper = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: block;
    margin-right: 16px; // adjust as needed
  }
`;

export const BurgerIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
`;

export const StyledDropdown = styled(Dropdown)`
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-popup.ant-dropdown-menu.ant-dropdown-menu-light {
  padding: 20px !important;

}

.ant-dropdown-menu-submenu{
  padding: 20px !important;
}
.ant-dropdown-menu.ant-dropdown-menu-sub.ant-dropdown-menu-vertical{
padding: 22px !important;
.ant-dropdown-menu-item ant-dropdown-menu-item-only-child {
    padding: 5px 4px !important;
  }
}
  
`;

export const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    border: 3px solid rgb(244, 245, 247) !important;
  }
`;